import React from "react"
import styles from "./styles.module.css"
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ProceedButton from "../../components/proceedButton";

class AlertModal extends React.Component {
  render() {
    const { isOpen=false, toggle=()=>{}, headerText='', bodyText='', option1, option2, loading=false } = this.props;
    
    return (
      <>
        <Modal isOpen={isOpen} toggle={toggle}>
              <div className="border_bottom">
                <div className="text-center">
                <ModalHeader tag="h2" toggle={toggle}>{headerText}</ModalHeader>
                </div>
              </div>
            <ModalBody className="text-center">
            {bodyText.map((x,idx) => <span key={idx} className={styles.bodyText}>{x}</span>)}
            </ModalBody>
            <ModalFooter>
                {
                    loading ?
                    <div className={[styles.modalButton,"text-center","w-100"].join(' ')}>
                        <div className={styles.proceedButtonContainer}>
                            <ProceedButton loading={true} borderRadius={3}/>
                        </div>
                    </div>
                    :
                    <div className={[styles.modalButton,"text-center","w-100"].join(' ')}>
                      { option1 && <span onClick={option1.onClick} className={["btn", styles.light_btn, "rounded","m-3","light_btn"].join(" ")}>{option1.text}</span> }
                      { option2 && <span onClick={option2.onClick} className={["btn", styles.dark_btn, 'btn-primary', "rounded","m-3"].join(" ")}>{option2.text}</span> }
                    </div>
                }
            </ModalFooter>
        </Modal>
      </>
    )
  }
}

export default AlertModal